import { useEffect, useMemo } from "react";
import { useUserSetting } from "hooks/UserSettingsHooks";
import { useIsAuthenticated } from "core/iam/AuthenticationHooks";
import { useUpdateUserLocale } from "generated/api/users/users";

export function LocaleUpdater() {
  const isLoggedIn = useIsAuthenticated();
  const timezone = useMemo(
    () => Intl.DateTimeFormat().resolvedOptions().timeZone,
    [],
  );
  const [language, _, isLoading] = useUserSetting("language", {
    query: { enabled: isLoggedIn },
  });

  const { mutate: updateLocale } = useUpdateUserLocale();

  useEffect(() => {
    if (!isLoading && isLoggedIn) {
      updateLocale({ data: { language, timezone } });
    }
  }, [timezone, language, isLoggedIn]);

  return null;
}
